import { UNSAFE_initIfNeeded } from '@atlassian/jira-feature-gates-unsafe-init';
import getMeta from '@atlassian/jira-get-meta';
import type { Flags } from '../../common/types';
import { parseFeatureFlagValue } from '../parse-feature-flag-value';

const getJsonMetaContent = (metaTagName: string): Flags | undefined => {
	const featureFlags = getMeta(metaTagName);
	if (featureFlags != null && featureFlags !== '') {
		try {
			return JSON.parse(featureFlags);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			throw new Error(`Can't parse '${metaTagName}' value`);
		}
	}
	return undefined;
};

type WindowFlagVars = {
	featureFlags: Flags | undefined;
	ssr__feFeatureFlags: Flags | undefined;
	ssr__allFeatureFlags: Flags | undefined;
};

// ajs-fe-feature-flags contains ALL frontend flags (boolean, string and JSON flags)
export const nonMemoizedGetAllFeatureFlags = (): Flags => {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const globalVar = (typeof window !== 'undefined'
		? window
		: globalThis) as unknown as WindowFlagVars;

	const featureFlags =
		globalVar.featureFlags ||
		getJsonMetaContent('ajs-fe-feature-flags') ||
		globalVar.ssr__allFeatureFlags ||
		globalVar.ssr__feFeatureFlags ||
		{};

	// Initialise Statsig here if it's enabled
	if (parseFeatureFlagValue(featureFlags, 'statsig-jira-integration_3faz9', false)) {
		UNSAFE_initIfNeeded();
	}

	return featureFlags;
};

let memoizedFeatureFlags: Flags | undefined;

const memoizedGetAllFeatureFlags = (): Flags => {
	if (memoizedFeatureFlags == null) {
		memoizedFeatureFlags = nonMemoizedGetAllFeatureFlags();
	}
	return memoizedFeatureFlags;
};

export default memoizedGetAllFeatureFlags;
